import axios from "axios";

// Same-origin when the page is served from the same site as the API (prod: eathiplate.com /
// www.eathiplate.com); otherwise the configured backend URL (preview / local dev).
const configured = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const sameSite = (() => {
  try {
    const here = window.location.hostname.replace(/^www\./, "");
    const there = new URL(configured).hostname.replace(/^www\./, "");
    return here === there;
  } catch {
    return false;
  }
})();
export const BACKEND = sameSite ? window.location.origin : configured;
export const API = `${BACKEND}/api`;

export const imgSrc = (src) => (src && src.startsWith("/") ? `${BACKEND}${src}` : src);

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
